import React, { useId } from "react";

/**
 * HostelNow logo mark — bright sunrise gradient with a stylized bunk bed
 * forming an "H" shape, topped by a cheerful star spark.
 * Palette: golden yellow → coral gradient · cream mattresses · terracotta shadow.
 */
export function LogoMark({ size = 36, className = "" }) {
  const gradId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className={className}
      aria-label="HostelNow logo"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFD166" />
          <stop offset="55%" stopColor="#FB923C" />
          <stop offset="100%" stopColor="#EA580C" />
        </linearGradient>
      </defs>

      {/* Bright sunrise-gradient backdrop */}
      <rect width="40" height="40" rx="10" fill={`url(#${gradId})`} />

      {/* Cheerful star spark top-right */}
      <path
        d="M 31.5 6 L 32.3 7.7 L 34.2 8 L 32.8 9.3 L 33.2 11.2 L 31.5 10.3 L 29.8 11.2 L 30.2 9.3 L 28.8 8 L 30.7 7.7 Z"
        fill="#FFF7ED"
      />

      {/* Bunk bed frame — cream H silhouette */}
      {/* Left post */}
      <rect x="9" y="9" width="3.8" height="23" rx="1.6" fill="#FFF7ED" />
      {/* Right post */}
      <rect x="27.2" y="9" width="3.8" height="23" rx="1.6" fill="#FFF7ED" />

      {/* Top bunk mattress */}
      <rect x="9" y="13.5" width="22" height="4" rx="1.5" fill="#FFF7ED" />
      {/* Top pillow */}
      <rect x="11" y="14.3" width="4" height="2.4" rx="1" fill="#EA580C" />

      {/* Bottom bunk mattress */}
      <rect x="9" y="24" width="22" height="4" rx="1.5" fill="#FFF7ED" />
      {/* Bottom pillow */}
      <rect x="11" y="24.8" width="4" height="2.4" rx="1" fill="#EA580C" />
    </svg>
  );
}

export function LogoLockup({ size = 36, className = "", tld = true }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <LogoMark size={size} />
      <span className="font-display font-black text-xl tracking-tight leading-none text-stone-900">
        The<span className="text-orange-600">HostelNow</span>{tld && <span className="text-[11px] tracking-[0.15em] uppercase text-amber-600 font-bold align-super ml-0.5">.com</span>}
      </span>
    </span>
  );
}

export default LogoMark;
